// Centralized color constants for use in JavaScript/TypeScript
// These match the Tailwind config colors

export const COLORS = {
  // Primary orange brand color - matches --primary CSS variable
  PRIMARY: "#fa7532",
  PRIMARY_HOVER: "#E2631B",

  // Selected/active state colors
  SELECTED: "#0ea5e9",

  // Surface colors for backgrounds
  SURFACE: "#F5F7F7",
  SURFACE_DARK: "#E8EDF0",
  SURFACE_HOVER: "#D5DDE1",

  // Semantic colors
  SUCCESS: "#36B25F",
  SUCCESS_LIGHT: "#daf4e2",
  DANGER: "#E5342E",
  DANGER_LIGHT: "#FAE6E6",
  WARNING: "#E5941B",
  WARNING_LIGHT: "#FAF1E6",

  // Header/navigation dark color
  HEADER: "#212A33",

  // Tooltip background (slate-600)
  TOOLTIP: "#475569",

  // Placeholder/muted text
  PLACEHOLDER: "#C2C2C2",

  // Gray scale (matching Tailwind)
  GRAY_PRIMARY: "#666666",
  GRAY_SECONDARY: "#999999",
  GRAY_600: "#4B5563", // Tailwind gray-600
  GRAY_800: "#1F2937", // Tailwind gray-800
} as const;
